import React, { useEffect, useState } from 'react'
import { Form, Table } from 'react-bootstrap'
import * as Api from "../../config/Apis"
import endPoints from "../../config/endpoints";

const languages = [
  { label: "English", value: "en" },
  { label: "Hindi", value: "hi" },
  { label: "French", value: "fr" },
  { label: "Spanish", value: "es" },
  { label: "Sweden", value: "sv" },
  { label: "Germany", value: "de" },
  { label: "Denmark", value: "da" },
  { label: "Japan", value: "jp" },
  { label: "Italian", value: "it" },
  { label: "Russian", value: "ru" },
  { label: "Norway", value: "no" },
  { label: "Arabic", value: "ar" },
  { label: "Finland", value: "fi" },
  { label: "Netherlands", value: "nl" },
]
export default function Translate() {
  const [loading, setLoading] = React.useState(true)
  const [tableData, setTableData] = React.useState([])
  const [languageKeys, setLanguageKeys] = React.useState([])
  const [value, setValue] = useState({})
  const [payload, setPayload] = useState({ translations: [] });
  const [newKey, setNewKey] = useState({
    show: false,
    key: "",
    values: "",
    category: ""
  });

  const handleChange = (e, row) => {
    const { name, value } = e.target;
    setValue(prev => {
      const updatedFormValues = {
        ...prev,
        [row.key]: {
          ...(prev[row.key] || {}),
          [name]: value
        }
      };
      const translations = Object.entries(updatedFormValues).map(
        ([rowId, editedValues]) => {
          const originalRow = tableData.find(item => item.key === rowId);

          return {
            key: originalRow.key,
            values: {
              ...originalRow.values,
              ...editedValues
            }
          };
        }
      );

      setPayload({ translations });

      return updatedFormValues;
    });
  };


  const getData = () => {
    Api.GetApi(endPoints.TRANSLATION).then(res => {
      setLoading(false)
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        if (res.data.data) {
          setTableData(res.data.data)
          setLanguageKeys(Object.keys(res.data.data[0].values || {}))
        }
      }
    })
  }
  const save = () => {
    let body = {
      ...payload
    }
    if (payload.translations.length) {
      Api.PostApi(endPoints.TRANSLATION_UPDATE, body).then(res => {
        if (res.error === true) {
          Api.Alert(res.response.data.error, "error")
        } else {
          Api.Alert(res.data.data.message, "success")
          getData()
        }
      })
    }
  }

  const handleKeysChange = (e) => {
    const { name, value } = e.target;
    setNewKey(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const addKey = () => {
    setNewKey({ ...newKey, show: true })
  }
  const addKeySubmit = () => {
    let body = {
      translations: [
        {
          key: newKey.key.split(" ").join("_").toLowerCase(),
          values: {
            en: newKey.values,
          },
          category: newKey.category
        }
      ]
    }
    Api.PostApi(endPoints.TRANSLATION_UPDATE, body).then(res => {
        if (res.error === true) {
          Api.Alert(res.response.data.error, "error")
        } else {
          Api.Alert(res.data.data.message, "success")
          getData()
          cancelKey()
        }
      })
  }
  const cancelKey = () => {
    setNewKey({
      show: false,
      key: "",
      values: "",
      category: ""
    });
  }

  useEffect(() => {
    getData();
  }, [])


  return (
    <main>
      {loading ?
        <div className="loader"></div>
        : null
      }
      <div className='container-fluid'>
        <div className='card'>
          <div className='card-body'>
            <div className='main_heading'>
              <h1>Translate</h1>
              <div className='d-flex gap-3'>
                <button className='btn btn-outline-primary btn-sm' onClick={addKey}>+ Add new key</button>
                <button className='btn btn-primary btn-sm' onClick={save}>Save</button>
              </div>
            </div>
            {newKey.show ?
              <div className='newKeys_block'>
                <h4 className='mb-2'>Add New Key</h4>
                <Form.Group className="mb-0 login_form d-flex gap-2">
                  <Form.Control onChange={handleKeysChange} name="key" value={newKey.key} placeholder="Enter key name" />
                  <Form.Control onChange={handleKeysChange} name="values" value={newKey.values} placeholder="Enter text (English)" />
                  <Form.Control onChange={handleKeysChange} name="category" value={newKey.category} placeholder="Enter category" />
                  <button className='btn btn-primary btn-sm px-5' onClick={addKeySubmit}>Save</button>
                  <button className='btn btn-outline-primary btn-sm px-5' onClick={cancelKey}>Cancel</button>
                </Form.Group>
              </div>
              : null
            }
            <div className='login_form translate_table'>
              {tableData.length ?
                <Table responsive hover>
                  <thead>
                    <tr>
                      {/* <th>Key</th>
                       {languageKeys.map(lang => {
                        const langLabel =
                          languages.find(l => l.value === lang)?.label || lang;

                        return (
                          <th key={lang}>{langLabel}</th>
                        );
                      })} */}
                      {languages.map(lang => {
                        return (
                          <th key={lang.value} style={{ minWidth: "200px", maxWidth: "200px" }}>{lang.label}</th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map(row => (
                      <tr key={row.key}>
                        {/* <td>{row.key}</td> */}
                        {languages.map(lang => (
                          <td key={lang.value}>
                            <Form.Group className="mb-0">
                              <Form.Control as="textarea" name={lang.value} value={
                                value[row.key]?.[lang.value] ??
                                row.values?.[lang.value] ??
                                ""
                              } onChange={(e) => handleChange(e, row)} />
                            </Form.Group>

                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                : null
              }
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
